import React, {Component,Fragment} from 'react';
import marketStyle from '../css/markets.css';
import OddsCard from './oddsCard';
import {getText} from "../../../../../helpers/localization";
import {generateFav, generateRandom, getMarketByCode} from '../helpers/marketHelpers';
import {addOpenBet, checkForQuickSelect, removeOpenBet} from "../../../actions/openBetsActions";
import {SINGLE} from "../../../../../constants/identifiers";
import {MATCHDAY_QUICK_FAV_TYPE, MATCHDAY_QUICK_RANDOM_TYPE} from "../constants/identifiers";
import { setSelectedMatchdayEventId } from "../../../../../actions/eventsActions";
import { getBonusPercentage } from '../helpers/matchdayHelper';

class UnderOverThreeFive extends Component {

    constructor(props) {
        super(props);
    }
    _openMoreBets(matchdayEventId) {
        this.props.store.dispatch(setSelectedMatchdayEventId(matchdayEventId, this.props.store));
    }

    _activeButton(eventRef,active){
        if(active){
            eventRef.target.classList.add(marketStyle.quickButton_active);
        }else{
            eventRef.target.classList.remove(marketStyle.quickButton_active);
        }
    }

    render() {
        let store = this.props.store;
        let matchdayMarkets = this.props.matchdayMarkets;
        let underOver35Markets=matchdayMarkets.map((eventMarket,index) => {
            let teamNameStyle = this.props.isGreekMatchday ? marketStyle.teamNameGreek : marketStyle.teamName;
            return (<div className={marketStyle.marketGroup} key={index}>
                <div className={marketStyle.headerColumn}>
                    <div className={marketStyle.marketTeam}>
                        <b className={marketStyle.headerPadding}>
                    <span className={`${teamNameStyle}`} onClick={() => this._openMoreBets(eventMarket.event.eventId)}>
                        { getText('Matchday_'+eventMarket.event.teamOne, this.props.store)} - { getText('Matchday_'+eventMarket.event.teamTwo, this.props.store)}
                    </span>
                        </b>
                    </div>
                </div>
                <div className={marketStyle.headerColumnMedium}>
                    <OddsCard store={store} market={eventMarket.market[1]} event={eventMarket.event}/>
                </div>
                <div className={marketStyle.headerColumnMedium}>
                    <OddsCard store={store} market={eventMarket.market[0]} event={eventMarket.event}/>
                </div>
                <div className={marketStyle.headerColumnMoreMarkets}>
                    <div className={marketStyle.customButtonContainer}>
                      <span className={marketStyle.morebetsButton}
                            onClick={() => this._openMoreBets(eventMarket.event.eventId)}><span>+6</span></span>
                    </div>
                </div>
            </div>);
        });

        let advancedView=(<Fragment>
            <div className={marketStyle.header}>
                <div className={marketStyle.scrollRef} ref={this.props.scrollRef}></div>
                <span className={marketStyle.headerColumn}>
              <b className={`${marketStyle.headerPadding} ${marketStyle.underOverLargeScreen}`}>{getText('UNDER_OVER_3_5',this.props.store)}</b>
              <b className={`${marketStyle.headerPadding} ${marketStyle.underOversmallScreen}`}>
                {getText('UNDER_OVER_35_INITIALS',this.props.store)}
              </b>
            </span>
                <span className={marketStyle.headerColumnMedium}>{getText('OVER',this.props.store)}</span>
                <span className={marketStyle.headerColumnMedium}>{getText('UNDER',this.props.store)}</span>
                <span className={marketStyle.headerColumnMoreMarkets}/>
            </div>
            <div className={`${marketStyle.marketGroup} ${marketStyle.marketGroupHeader} `} key={'QuickSelect'}>
                <div className={marketStyle.headerColumn}>
                    <div className={marketStyle.marketTeam}>
                        <b className={marketStyle.headerPadding}>{getText('QUICK_SELECT',this.props.store)}</b>
                    </div>
                </div>
                <div className={marketStyle.headerColumnMedium}>
                    <div className={marketStyle.customButtonContainer}>
                        <div className={marketStyle.quickButton}  onTouchStart={(evt) => this._activeButton(evt,true)}
                             onTouchEnd={(evt) => this._activeButton(evt,false)}
                             onClick={() => this._placeRandom()}>{this._getQuickButtonText('8RANDOM',this.props.store)}</div>
                    </div>
                </div>
                <div className={marketStyle.headerColumnMedium}>
                    <div className={marketStyle.customButtonContainer}>
                        <div className={marketStyle.quickButton}  onTouchStart={(evt) => this._activeButton(evt,true)}
                             onTouchEnd={(evt) => this._activeButton(evt,false)}
                             onClick={() => this._placeFavs()}>{this._getQuickButtonText('8FAVS',this.props.store)}</div>
                    </div>
                </div>
                <div className={marketStyle.headerColumnMoreMarkets}/>
            </div>
        </Fragment>);

        return (
            <div>
                {advancedView}
                {underOver35Markets}
            </div>
        );
    }


    _placeRandom() {
        let betType = getMarketByCode(this.props.matchdayMarkets[0].market[0].code);
        let random = generateRandom(this.props.matchdayMarkets, 1, 2);

        if (checkForQuickSelect(betType, random, this.props.store.getState().vpp.openBetsSimpleList)) {
            this.props.store.getState().vpp.openBetsSimpleList.forEach(bet => {
                if (bet.bets.length == 1 && bet.bets[0].betType.code === betType.code && random.some(betRandom => betRandom.event.eventId == bet.bets[0].event.eventId && betRandom.event.channel == bet.bets[0].event.channel)) {
                    this.props.store.dispatch(removeOpenBet(bet));
                }
            });

            random.forEach(randomMarket => {
                let bet = {
                    game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
                    event: randomMarket.event,
                    betType: betType,
                    market: randomMarket.market,
                    type: SINGLE,
                    selectionType: MATCHDAY_QUICK_RANDOM_TYPE,
                    multiplier: 1
                };
                this.props.store.dispatch(addOpenBet(bet, this.props.store.getState().vpp.openBetsSimpleList));
            })
        }
    }

    _placeFavs() {
        let betType = getMarketByCode(this.props.matchdayMarkets[0].market[0].code);
        let favs = generateFav(this.props.matchdayMarkets);

        if (checkForQuickSelect(betType, favs, this.props.store.getState().vpp.openBetsSimpleList)) {
            this.props.store.getState().vpp.openBetsSimpleList.forEach(bet => {
                if (bet.bets.length == 1 && bet.bets[0].betType.code === betType.code && favs.some(betFav => betFav.event.eventId == bet.bets[0].event.eventId && betFav.event.channel == bet.bets[0].event.channel)) {
                    this.props.store.dispatch(removeOpenBet(bet));
                }
            });

            favs.forEach(favMarket => {
                let bet = {
                    game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
                    event: favMarket.event,
                    betType: betType,
                    market: favMarket.market,
                    type: SINGLE,
                    selectionType: MATCHDAY_QUICK_FAV_TYPE,
                    multiplier: 1
                };
                this.props.store.dispatch(addOpenBet(bet, this.props.store.getState().vpp.openBetsSimpleList));
            })
        }
    }
    _getQuickButtonText(buttonKey, store){

        let bonusPercentage = getBonusPercentage(store);
        let quickButtonText = bonusPercentage===null ? <Fragment >{getText(buttonKey, store)}</Fragment>:
            <div className={marketStyle.quickButtonParent}>
                <div className={marketStyle.quickButtonText}>{getText(buttonKey, store)}</div>
                <div className={marketStyle.quickButtonBonus}>{bonusPercentage}</div>
            </div>;
        return quickButtonText;

    }

}
export default UnderOverThreeFive;


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/components/underOverThreeFive.js